/**
 * Hub-typed BROWSER Supabase client. The `@wtc/supabase` browser factory is
 * generic (`DB = any` default); binding hub's generated `Database` here gives
 * client-side `.from().select()` the same compile-time column + value checking
 * the server `getHubServiceClient()` provides — so a renamed/removed column is
 * a `tsc` error instead of a runtime PostgREST surprise.
 *
 * Use this in client hooks that query Supabase directly. Server code uses
 * `getHubServiceClient()` / `getHubServerClient()` from `./typed-client`.
 */
import type { SupabaseClient } from "@supabase/supabase-js";
import { getBrowserSupabaseClient } from "@wtc/supabase";
import type { Database } from "./database.types";

export function getHubBrowserClient(): SupabaseClient<Database> {
  return getBrowserSupabaseClient<Database>();
}
